import React, { useState } from "react";
import Navbar from "../../components/ui/Navbar";
import { Alert } from "../../components/ui/alert";
import InformacionPage from "./InformacionPage";
import EmpresaPage from "./EmpresaPage";
import { hasPermission } from "../../utils/permissions";
import { LoaderPinwheel, UserCircle2, Building2 } from "lucide-react";

const ProfilePage = () => {
  const [section, setSection] = useState("usuario");
  const [error] = useState("");

  const renderSection = () => {
    switch (section) {
      case "usuario":
        return <InformacionPage />;
      case "empresa":
        return <EmpresaPage />;
      default:
        return <InformacionPage />;
    }
  };

  if (!section) {
    return (
      <div className="flex flex-col items-center justify-center h-screen text-gray-600">
        <LoaderPinwheel className="w-10 h-10 mb-3 animate-spin text-blue-600" />
        <p>Cargando perfil...</p>
      </div>
    );
  }

  const tabs = [
    { key: "usuario", label: "Mi perfil", Icon: UserCircle2 },
    ...(hasPermission("empresa.editar")
      ? [{ key: "empresa", label: "Empresa", Icon: Building2 }]
      : []),
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      <div className="container mx-auto px-4 py-6 pt-20 md:pt-28 space-y-6">
        {/* Header */}
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-600 rounded-xl">
            <UserCircle2 className="h-6 w-6 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Perfil</h1>
            <p className="text-sm text-gray-500">
              Gestiona tu información personal y de empresa
            </p>
          </div>
        </div>

        {error && (
          <Alert variant="destructive">
            <p>{error}</p>
          </Alert>
        )}

        {/* Card con tabs */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
          {/* Tab navigation */}
          <div className="flex border-b border-gray-200">
            {tabs.map(({ key, label, Icon }) => (
              <button
                key={key}
                onClick={() => setSection(key)}
                className={`flex items-center gap-2 px-6 py-3.5 text-sm font-medium transition-colors border-b-2 -mb-px ${
                  section === key
                    ? "border-blue-600 text-blue-600 bg-blue-50/60"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-50"
                }`}
              >
                <Icon className="h-4 w-4" />
                {label}
              </button>
            ))}
          </div>

          {/* Contenido */}
          <div className="p-6">{renderSection()}</div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
